import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  menuTrigger: {
    marginLeft: '4px'
  }
});
export default useStyles;